import { FormControl } from '@angular/forms';

const PHONE_REGEXP = /\(?([0-9]{2})\)[[\s*]([0-9])?([0-9]{4})([\-])([0-9]{4})$/;

export function phoneValidator(control: FormControl): { [invalidPhone: string]: boolean } {
  if (control.value.length < 14 || !PHONE_REGEXP.test(control.value)) {
    return { invalidPhone: true };
  }

  return null;
}
